<template>
  <footer class="table-pagination">
    <span aria-live="polite">
      Показано {{ total ? (page - 1) * pageSize + 1 : 0 }}–{{ Math.min(page * pageSize, total) }} из {{ total }}
    </span>

    <div>
      <button
        type="button"
        :disabled="page <= 1"
        @click="$emit('change', page - 1)"
      >
        <ChevronLeft :size="16" />
        Назад
      </button>

      <span>{{ page }} / {{ pages }}</span>

      <button
        type="button"
        :disabled="page >= pages"
        @click="$emit('change', page + 1)"
      >
        Вперёд
        <ChevronRight :size="16" />
      </button>
    </div>
  </footer>
</template>

<script>
import { ChevronLeft, ChevronRight } from 'lucide-vue'

export default {
  name: 'TablePaginationV2',
  components: {
    ChevronLeft,
    ChevronRight
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    pages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss"/>
